import { lazy } from "react";

const TransportationPage = lazy(() => import("./pages/TransportationPage"));

export const transportationRoutes = [
  { path: "/transportation", element: <TransportationPage /> },
];
